// extracted by mini-css-extract-plugin
module.exports = {"small":"400px","medium":"640px","tablet":"768px","ipad":"769px","large":"1200px","xlarge":"1600px","choose_style":"_breakpoints_choose_style__3p23F"};